import qs from 'qs'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const EmailSent = () => {
    const [email, setEmail] = useState('')
    const location = useLocation()
    const navigate = useNavigate()
    
    useEffect(() => {
        let email = qs.parse(location.search, { ignoreQueryPrefix: true }).email
        
        if (typeof email === 'string') {
            setEmail(email)
        }
    }, [location])
    
    return (
        <div className="flex flex-col justify-center items-center" style={{ height: '99vh' }}>
            <div className="w-96 mx-auto">
                <div
                    style={{
                        marginBottom: '25px',
                        width: '80%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '20px auto',
                    }}>
                    <img src="img/logo.png" width="100%" height="100%" alt="" />
                </div>
                <div className="text-center">
                    <h2>Check your email</h2>
                    <p>We&apos;ve sent an email to {email.toLowerCase()}.</p>
                    <p>Please click the link in the email to confirm your address and activate your account.</p>
                    <span
                        className="text-muted"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate(`/resendemail?email=${email.toLowerCase()}`)}>
                        Click here if you can&apos;t see the email
                    </span>
                </div>
            </div>
        </div>
    )
}
